import { Card } from '@pwskills/rachnaui';
import React from 'react';
import { companyImage } from '@/utils/common/env.constants';

type Props = {
  company: { link: string; _id: string };
};

const ToolsCard = ({ company }: Props) => {
  const { link, _id } = company;
  return (
    <Card
      className="p-[6px] bg-white shadow-light rounded-2xl shrink-0 h-fit w-[218px] medium:!w-[285px] !m-0"
      key={_id}
    >
      <figure className="flex justify-center items-center">
        <img
          src={`${companyImage}/master_tool_images/${link}`}
          alt="tools"
          className="w-[60%] regular:!w-[210px] h-[80px] medium:!h-[96px]"
        />
      </figure>
    </Card>
  );
};

export default ToolsCard;
